import * as z from "zod";

export const upsertGuidance = {
  name: "upsertGuidance" as const,
  input: z.object({ guidance: z.string() }),
  output: z.void(),
};
